import { Route, Routes } from 'react-router-dom';
import Header from './components/header/header';
import Home from './routes/home';
import WhoWeAre from './routes/who-we-are';
import Training from './routes/training';
import TrainingDetails from './routes/training-detail';
import Testimonials from './routes/testimonials';
import GetInTouch from './routes/get-in-touch';
import NotFound from './routes/not-found';
import Footer from './components/footer/footer';
import "animate.css/animate.compat.css";
import './App.css';
import ThankYou from './routes/thank-you';
import PrivacyPolicy from './routes/privacy-policy';

function App() {

  return (
    <div className="App">
      <Header />
      <main className='ae-main-container'>
        <Routes>
          <Route element={<Home />} path='/' />
          <Route element={<WhoWeAre />} path='/who-we-are' />
          <Route path='/training' >
            <Route index element={<Training />} />
            <Route path=":training-detail" element={<TrainingDetails />} />
          </Route>
          <Route element={<Testimonials />} path='/testimonials' />
          <Route element={<GetInTouch />} path='/get-in-touch' />
          <Route path="/thank-you-for-contacting-us" element={<ThankYou />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
